<app-dark-mode-icon />
<app-sound />
